// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases as mdiAliases, mdi } from 'vuetify/iconsets/mdi';
import colors from 'vuetify/util/colors';

/** Match Vuetify 2 MDI alert icons (V3 changed warning/error). */
const aliases = {
  ...mdiAliases,
  success: 'mdi-check-circle',
  info: 'mdi-information',
  warning: 'mdi-exclamation',
  error: 'mdi-alert',
};

/**
 * Vuetify 3 plugin (vue3-migration kickoff).
 * Theme keys mirror the Vue 2 plugin as closely as Vuetify 3 allows.
 * Note: Vue 2 dark theme had typo 'default-conent' — corrected here.
 */
export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  defaults: {
    VTextField: {
      variant: 'underlined',
    },
    VSelect: {
      variant: 'underlined',
    },
    VAutocomplete: {
      variant: 'underlined',
    },
    VCombobox: {
      variant: 'underlined',
    },
    VTextarea: {
      variant: 'underlined',
    },
    VBtn: {
      rounded: 'sm',
    },
    VCard: {
      rounded: 'sm',
    },
    VDataTable: {
      density: 'compact',
    },
    VDataTableServer: {
      density: 'compact',
    },
    VSwitch: {
      color: 'primary',
    },
    VCheckbox: {
      color: 'primary',
    },
  },
  theme: {
    defaultTheme: 'light',
    variations: {
      colors: ['primary', 'default-content', 'default-panel', 'background'],
      lighten: 5,
      darken: 5,
    },
    themes: {
      light: {
        dark: false,
        colors: {
          'default-content': colors.shades.black,
          'default-panel': colors.shades.white,
          background: colors.grey.lighten5,
          primary: colors.blue.darken2,
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00',
        },
      },
      dark: {
        dark: true,
        colors: {
          'default-content': colors.shades.white,
          'default-panel': '#1e1e1e',
          background: colors.grey.darken4,
          primary: colors.blue.lighten1,
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00',
        },
      },
    },
  },
});
